export const enum ModalTypes {
  SIGNUP = "SIGNUP",
  LOGIN = "LOGIN",
  PRIVACY_POLICY = "PRIVACY_POLICY",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  CONFIRM_FORGOT_PASSWORD = "CONFIRM_FORGOT_PASSWORD",
  VERIFICATION_CODE = "VERIFICATION_CODE",
  USER_PROFILE = "USER_PROFILE",
  PHONE_NUMBER = "PHONE_NUMBER",
}
